<script>
import { nativeApps } from '../configuration.js'
import analyticsService from './../services/analytics-service'

export default {
    name: 'CustomNativeSmartBanner',
    data() {
        return {
            isVisible: false,
            appName: "FRISKY",
            appDescription: "Underground Electronic Music.",
            appStoreUrl: `https://apps.apple.com/app/${nativeApps.iosAppId}`,
            appIcon: "/images/icons/icon-72x72.png",
            localStorageKey: "ios-banner-dismissed",
            actionLabel: "Open App",
            dismissDuration: 24 * 60 * 60 * 1000 // 24 hours in milliseconds
        }
    },
    mounted() {
        const isIOS = /iphone|ipod|ipad/i.test(navigator.userAgent)
        const isInStandalone = window.navigator.standalone === true
        const dismissedData = localStorage.getItem(this.localStorageKey)
        const shouldShowBanner = !dismissedData || this.isDismissalExpired(dismissedData)

        if (isIOS && !isInStandalone && shouldShowBanner) {
            analyticsService.customIosAppBannerView()
            this.isVisible = true
        }
    },
    methods: {
        dismissBanner() {
            const dismissalData = JSON.stringify({
                timestamp: new Date().getTime()
            })
            localStorage.setItem(this.localStorageKey, dismissalData)
            this.isVisible = false
            analyticsService.customIosAppBannerDismiss()
        },
        isDismissalExpired(dismissedData) {
            try {
                const data = JSON.parse(dismissedData)
                const dismissedTime = data.timestamp
                const currentTime = new Date().getTime()

                return currentTime - dismissedTime > this.dismissDuration
            } catch (error) {
                return true
            }
        },
        navigateToApp() {
            analyticsService.customIosAppBannerClick()
            window.location.href = this.appStoreUrl
        }
    },
};
</script>

<template>
    <transition name="slide-down">
        <div
            v-if="isVisible"
            class="smart-banner"
        >
            <div class="banner-content">
                <img
                    :src="appIcon"
                    class="app-icon"
                    alt="FRISKY Icon"
                >
                <div class="info">
                    <div class="app-name">{{ appName }}</div>
                    <div class="app-description">{{ appDescription }}</div>
                    <a
                        class="download-btn"
                        @click="navigateToApp"
                    >{{ actionLabel }}</a>
                </div>
                <button
                    class="close-btn"
                    @click="dismissBanner"
                >×</button>
            </div>
        </div>
    </transition>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.smart-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: $s-m;
    background: $c-silver;
    border-bottom: 1px solid $c-frisky-fill;
}

.banner-content {
    display: flex;
    gap: $s-m;
    align-items: center;
    width: 100%;
    max-width: 768px;
}

.app-icon {
    width: 60px;
    height: 60px;
}

.info {
    flex-grow: 1;
}

.app-name {
    font-size: 16px;
    font-weight: bold;
    color: $c-grey-heavy-metal;
}

.app-description {
    font-size: 13px;
    color: $c-grey-mine-shaft;
}

.download-btn {
    display: inline-block;
    padding: $s-xs $s-m;
    margin-top: $s-s;
    color: $c-white;
    text-decoration: none;
    background-color: $c-azure-radiance;
    border-radius: 4px;
}

.close-btn {
    font-size: 24px;
    cursor: pointer;
    background: transparent;
    border: none;
}

.slide-down-enter-active,
.slide-down-leave-active {
    transition: transform 0.3s ease;
}

.slide-down-enter,
.slide-down-leave-to {
    transform: translateY(-100%);
}
</style>
